import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MpeDialogPage} from '../mpe-dialog-helper';

@Component({
  selector: 'app-dialog-footer',
  templateUrl: './dialog-footer.component.html',
  styleUrls: ['./dialog-footer.component.scss']
})
export class DialogFooterComponent {

  @Input() permittedToGoToSummary: boolean;
  @Input() backButtonText: string;
  @Input() backButtonValue: MpeDialogPage;
  @Input() nextButtonText: string;
  @Input() nextButtonValue: MpeDialogPage;
  @Input() nextButtonEnable: boolean;
  @Output() pageSelection = new EventEmitter<MpeDialogPage>();
  @Output() enableErrorMessage = new EventEmitter<boolean>();
  @Output() exportSelected = new EventEmitter<boolean>();
  readonly MpeDialogPage = MpeDialogPage;

  constructor() { }

  onBackButtonClick(): void {
    this.enableErrorMessage.emit(false);
    this.pageSelection.emit(this.backButtonValue);
  }

  onNextButtonClick(): void {
    if (!this.permittedToGoToSummary && this.nextButtonValue === MpeDialogPage.SUMMARY) {
      this.enableErrorMessage.emit(true);
    } else if (this.nextButtonValue === MpeDialogPage.EXPORTED) {
      this.exportSelected.emit(true);
      this.pageSelection.emit(this.nextButtonValue);
    } else {
      this.enableErrorMessage.emit(false);
      this.pageSelection.emit(this.nextButtonValue);
    }
  }
}
